<template>
  <span class="cell" :class="getItemClass">
    <div v-if='getItemClass' class='diff' :class='{"big-diff":isBig}'>
      <svg class="icon-arrow" :class="getItemClass" width="9" height="12" viewBox="0 0 9 12" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.5 11.25L8.875 6.875L8.25812 6.25813L4.9375 9.57438L4.9375 0.75L4.0625 0.75L4.0625 9.57438L0.741874 6.25813L0.125 6.875L4.5 11.25Z" />
      </svg>
      <span v-if='isShowRate' class='text'>{{ Math.abs(rateValue).toFixed(2) }}</span>
    </div>

    <span>{{ (Number.isNaN(value) || value == null) ? "-" : value }}</span>
  </span>
</template>

<script>
export default {
  props: {
    rateValue: {
      type: Number,
      default: 0,
    },
    value: {
      type: [String, Number],
      default: '-',
    },
    isShowRate: {
      type: Boolean,
      default: false,
    },
    isBig: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    getItemClass() {
      if (this.rateValue > 0) {
        return 'up';
      } else if (this.rateValue < 0) {
        return 'down';
      } else {
        return '';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.cell {
  font-weight: 500;
  min-width: 60px !important;
  
  &.up {
    background-color: #D8FFF5;
    color: var(--success-color) !important;
  }

  &.down {
    background-color: #FFD9E2;
    color: var(--danger-color) !important;
  }
}

.diff {
  display: flex;
  flex-flow: column;
  margin-right: 5px;
  align-items: center;

  .text {
    font-size: 12px;
  }
}

.big-diff {
  margin-right: 10px;
}

.icon-arrow {
  transition: transform 0.3s ease;

  &.up {
    transform: rotate(180deg);
    fill: var(--success-color);
  }

  &.down {
    transform: rotate(0deg);
    fill: var(--danger-color);
  }
}

@media screen and (max-width: 468px) {
  .diff {
    display: flex;
    flex-flow: column;
    margin-right: 3px;
    align-items: center;

    .text {
      font-size: 10px;
    }
  }
}
</style>